import React, { useState } from "react";
import langData from "../locales/langData.json";

const AdminLogin = ({ language }) => {
  const t = langData[language]?.adminLogin || langData.en.adminLogin;

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();

    if (username === "admin" && password === "1234") {
      localStorage.setItem("isAdmin", "true");
      alert(t.success);
      window.location.href = "/";
    } else {
      alert(t.error);
    }
  };

  return (
    <div
      className="container d-flex justify-content-center align-items-center"
      style={{ minHeight: "100vh" }}
      dir={language === "ar" ? "rtl" : "ltr"}
    >
      <div className="card p-4" style={{ maxWidth: 400, width: "100%" }}>
        <h4 className="text-center mb-4">{t.title}</h4>

        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <input
              type="text"
              className="form-control contact-input"
              placeholder={t.username}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <input
              type="password"
              className="form-control contact-input"
              placeholder={t.password}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="explore-btn w-100">
            {t.login}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
